module.exports = __webpack_public_path__ + "static/img/tooltip-new-banner.0fdedcd8.svg";